<template>
  <component :is="tag" ref="root" class="sp-cta-actions" flex>
    <slot />
  </component>
</template>

<script setup>
import { ref } from "vue";
import { useDefaults } from "../../composables/defaults";

const root = ref(null);
const props = defineProps({
  tag: {
    type: String,
    default: "sp-container",
  },
});

useDefaults(props, root, "SpCtaActions");
</script>

<style scoped>
.sp-cta-actions {
  background-color: lightgray;
  padding: 1rem;
  align-items: center;
  justify-content: center;
}
</style>
